export default __webpack_public_path__ + "static/media/arrow-up-right.5365e13c.svg";